<template>
  <div class="qa-top-page container pb-70">
    <b-loading :active.sync="isLoading" :can-cancel="false" />
    <div v-if="breadcrumbs.length" class="breadcrumbs-div">
      <QABreadcrumbs
        :breadcrumbs="breadcrumbs"
        class="breadcrumbs-categories"
      />
    </div>
    <MessageArea />
    <div class="container-inner mt-30">
      <QAHeaderSearch />
      <QACategories />

      <div v-show="!state || state === 'resolved'" class="qa-top__resolves">
        <QAListBlock
          :items="resolvedList.items"
          :no-result-msg="$t('EF2162_Content')"
          :title="state === 'resolved' ? '解決済みの質問一覧' : '解決済みの質問'"
        />
        <div v-show="showRLPaginationLink" class="qa-view-more">
          <router-link :to="{ name: 'QATop', query: { state: 'resolved' } }" class="d-flex is-pulled-right">解決済みの質問をもっと見る<b-icon icon="chevron-right" class="c-text-grey4"/></router-link>
        </div>
        <b-pagination
          v-show="showRLPagination"
          :total="resolvedList.pagination.total"
          :current.sync="resolvedList.pagination.currentPage"
          :per-page="countPerPageItem"
          :simple="false"
          :rounded="false"
          order="is-centered"
          @change="pageRLChange"
        />
      </div>

      <div v-show="!state || state === 'open'" class="qa-top__opens mt-40">
        <QAListBlock
          :items="openList.items"
          :no-result-msg="$t('EF2162_Content')"
          :title="state === 'open' ? '回答受付中の質問一覧' : '回答受付中の質問'"
        />
        <div v-show="showOLPaginationLink" class="qa-view-more">
          <router-link :to="{ name: 'QATop', query: { state: 'open' } }" class="d-flex is-pulled-right">回答受付中の質問をもっと見る<b-icon icon="chevron-right" class="c-text-grey4"/></router-link>
        </div>
        <b-pagination
          v-show="showOLPagination"
          :total="openList.pagination.total"
          :current.sync="openList.pagination.currentPage"
          :per-page="countPerPageItem"
          :simple="false"
          :rounded="false"
          order="is-centered"
          @change="pageOLChange"
        />
      </div>
    </div>
  </div>
</template>

<style lang="scss" src="../qa.scss">
</style>

<script>
import messageUtils from '@/utils/mixins/messageUtils';
import MessageArea from '@/components/common/message-area/message-area';
import IconAngleRight from '@/components/common/icon-angle-right';
import QABreadcrumbs from '@/components/breadcrumbs/breadcrumbs-categories';
import QAHeaderSearch from '../components/header-search';
import QACategories from '../components/categories';
import QAListBlock from './list-block';
import { searchQuestion } from '@/services/forum.service';
export default {
  name: 'QATopPage',
  components: {
    IconAngleRight,
    MessageArea,
    QABreadcrumbs,
    QAHeaderSearch,
    QACategories,
    QAListBlock
  },
  mixins: [messageUtils],
  data() {
    return {
      breadcrumbs: [],
      state: null,
      resolvedList: {
        items: [],
        pagination: {
          total: 0,
          currentPage: 1
        }
      },
      openList: {
        items: [],
        pagination: {
          total: 0,
          currentPage: 1
        }
      },
      defaultPagination: {
        perPage: 5,
        perSingleStatePage: 10
      }
    };
  },
  computed: {
    showRLPaginationLink: function() {
      return !this.state && this.resolvedList.pagination.total > this.defaultPagination.perPage;
    },
    showOLPaginationLink: function() {
      return !this.state && this.openList.pagination.total > this.defaultPagination.perPage;
    },
    showRLPagination: function() {
      return (
        this.state === 'resolved' && this.resolvedList.pagination.total > this.defaultPagination.perSingleStatePage
      );
    },
    showOLPagination: function() {
      return this.state === 'open' && this.openList.pagination.total > this.defaultPagination.perSingleStatePage;
    },
    countPerPageItem: function() {
      return this.state ? this.defaultPagination.perSingleStatePage : this.defaultPagination.perPage;
    }
  },
  watch: {
    $route() {
      this.setRouteQuery();
    }
  },
  async mounted() {
    this.setRouteQuery();
  },
  methods: {
    setRouteQuery() {
      this.state = this.$route.query && this.$route.query.state ? this.$route.query.state : null;
      // init breadcrumbs
      this.breadcrumbs = [{ name: 'ホーム', link: '/' }, { name: 'ユーザーQ&A', link: `/question-answer` }];

      switch (this.state) {
        case 'open':
          this.breadcrumbs.push({ name: '回答受付中の質問一覧', link: '' });
          // Force reload the page when change the link to open
          this.fetchOLData(1);
          break;

        case 'resolved':
          this.breadcrumbs.push({ name: '解決済みの質問一覧', link: '' });
          // Force reload the page when change the link to resolved
          this.fetchRLData(1);
          break;

        default:
          // If back event occurred, reload the page
          this.fetchRLData(1);
          this.fetchOLData(1);
          break;
      }
    },
    async fetchRLData(page) {
      const params = {
        keyword: null,
        self: null,
        category: null,
        status: 1,
        page,
        limit: this.countPerPageItem
      };

      this.clearMessage();
      this.loading++;

      const res = await searchQuestion(params);

      this.loading--;
      if (res.status) {
        this.$set(this.resolvedList, 'items', res.result.data.data);
        this.$set(this.resolvedList.pagination, 'total', res.result.data.total);
      } else {
        this.setErrorMessage(res.result);
      }
    },
    async fetchOLData(page) {
      const params = {
        keyword: null,
        self: null,
        category: null,
        status: 0,
        page,
        limit: this.countPerPageItem
      };

      this.clearMessage();
      this.loading++;

      const res = await searchQuestion(params);

      this.loading--;
      if (res.status) {
        this.$set(this.openList, 'items', res.result.data.data);
        this.$set(this.openList.pagination, 'total', res.result.data.total);
      } else {
        this.setErrorMessage(res.result);
      }
    },
    pageRLChange(page) {
      this.fetchRLData(page);
      this.$set(this.resolvedList.pagination, 'currentPage', page);
    },
    pageOLChange(page) {
      this.fetchOLData(page);
      this.$set(this.openList.pagination, 'currentPage', page);
    }
  }
};
</script>
